























import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { ITransactionInput } from '@/models/transaction';
import dayjs from 'dayjs';

@Component
export default class DatePicker extends Vue {
  @State private draftTransaction!: ITransactionInput;

  private menu = false;

  get date() {
    return dayjs(this.draftTransaction.timestamp)
      .format('YYYY-MM-DD');
  }

  set date(value) {
    const date = dayjs(value);
    this.$store.commit('updateDraftTransaction', {
      ...this.draftTransaction,
      timestamp: date.valueOf(),
    });
  }
}
